import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../fonts/Figtree-VariableFont_wght.ttf\",\"variable\":\"--font-figtree\"}],\"variableName\":\"figtree\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../fonts/Quicksand-VariableFont_wght.ttf\",\"variable\":\"--font-quicksand\"}],\"variableName\":\"quicksand\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/molecules/Snackbar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/contexts/AuthContext/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomePageDataProvider"] */ "/vercel/path0/src/contexts/HomePageDataContext/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MeusPedidosDataProvider"] */ "/vercel/path0/src/contexts/MeusPedidosDataContext/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SacolaDataProvider"] */ "/vercel/path0/src/contexts/SacolaDataContext/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SnackbarProvider"] */ "/vercel/path0/src/contexts/SnackbarContext/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StyledComponentsRegistry"] */ "/vercel/path0/src/styles/StyledComponentsRegistry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/styles/ThemeProviderWrapper.tsx");
